import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Input,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Select,
  Checkbox,
  VStack,
  Text,
  FormErrorMessage,
  Image,
  HStack,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  IconButton,
  Divider,
  Radio,
  RadioGroup,
  Stack,
  Badge,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import CustomDatePicker from "./CustomDatePicker"; // นำเข้า CustomDatePicker
import { StandardPageTitle, StandardHeader } from "../themes/StandardHeader";
import ApiService from "../services/ApiService"; // นำเข้า ApiService
import { AuthContext } from "../context/AuthContext"; // เพิ่มการ import AuthContext
import { useDropzone } from "react-dropzone";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faLocationDot,
  faImage,
  faUser,
  faHouseChimney,
  faHatCowboy,
  faBuilding,
  faUserTie,
  faPlus,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { min } from "date-fns";

// เพิ่ม prop isEditMode เพื่อใช้ตรวจสอบว่าเป็นโหมดแก้ไขหรือไม่
const RegistrationFarmer = ({ isEditMode = false }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const { sessionId } = useContext(AuthContext) || {}; // ดึง sessionId จาก AuthContext
  const { isOpen: isSuccessDialogOpen, onOpen: onSuccessDialogOpen, onClose: onSuccessDialogClose } = useDisclosure();
  const { isOpen: isDuplicateDialogOpen, onOpen: onDuplicateDialogOpen, onClose: onDuplicateDialogClose } = useDisclosure();
  const [resendLoading, setResendLoading] = useState(false);
  
  // State สำหรับเลือกรูปแบบการลงทะเบียน
  const [registrationType, setRegistrationType] = useState("individual"); // "individual" หรือ "corporate"
  
  const [formData, setFormData] = useState({
    FarmerID: "",
    FirstName: "",
    LastName: "",
    FirstName2: "",
    LastName2: "",
    IDCard: "",
    Gender: "M",
    BirthDate: null,
    AddressNo: "",
    AddressMoo: "",
    AddressRoad: "",
    AddressSubdistrict: "",
    AddressDistrict: "",
    AddressProvince: "",
    AddressZipcode: "",
    Email: "",
    Phone: "",
    Address: "",
    ProfileImage: null,
    Remark: "",
    Status: "Active",
    Password: "",
    ConfirmPassword: "",
    
    // ข้อมูลนิติบุคคล
    FarmerType: "บุคคลธรรมดา", // "บุคคลธรรมดา" หรือ "นิติบุคคล"
    CorporateType: "", // ประเภทนิติบุคคล เช่น บริษัทจำกัด, ห้างหุ้นส่วนจำกัด ฯลฯ
    CompanyBranch: "", // สาขา

    // State สำหรับข้อมูลปศุสัตว์
    FarmName: "",
    // เปลี่ยน FarmAddress เป็น Object เพื่อเก็บรายละเอียด
    FarmAddress: {
      AddressNo: "",
      AddressMoo: "",
      AddressRoad: "",
      AddressSubdistrict: "",
      AddressDistrict: "",
      AddressProvince: "",
      AddressZipcode: "",
    },
    Livestock: {
      BeefCattle: 0,
      DairyCattle: 0,
      Buffalo: 0,
      Swine: 0,
      Chicken: 0,
      Duck: 0,
      Goat: 0,
      Sheep: 0,
      Quail: 0,
      Dog: 0,
      Cat: 0,
      Other: 0,
    },
  });
  
  // State สำหรับผู้ติดต่อประสานงาน (นิติบุคคล)
  const [contacts, setContacts] = useState([
    { id: 1, ContactName: "", ContactPhone: "", ContactEmail: "", IsPrimary: true }
  ]);
  
  const [errors, setErrors] = useState({});
  const [privacyChecked, setPrivacyChecked] = useState(false);
  // State สำหรับ checkbox 'ใช้ที่อยู่เดียวกัน'
  const [useSameAddress, setUseSameAddress] = useState(false);
  
  // ประเภทนิติบุคคล
  const corporateTypes = [
    "บริษัทจำกัด",
    "บริษัทมหาชนจำกัด",
    "ห้างหุ้นส่วนจำกัด",
    "ห้างหุ้นส่วนสามัญนิติบุคคล",
    "สหกรณ์",
    "วิสาหกิจชุมชน",
    "มูลนิธิ",
    "สมาคม",
    "อื่นๆ"
  ];
  
  // Handler สำหรับเปลี่ยนรูปแบบการลงทะเบียน
  const handleRegistrationTypeChange = (value) => {
    setRegistrationType(value);
    setFormData(prev => ({
      ...prev,
      FarmerType: value === "individual" ? "บุคคลธรรมดา" : "นิติบุคคล",
      // Reset fields ที่ไม่จำเป็นสำหรับแต่ละประเภท
      CorporateType: value === "individual" ? "" : prev.CorporateType,
      CompanyBranch: value === "individual" ? "" : prev.CompanyBranch,
      LastName: value === "corporate" ? "" : prev.LastName,
      Gender: value === "corporate" ? "" : "M",
      BirthDate: value === "corporate" ? null : prev.BirthDate,
    }));
    
    // Reset contacts ถ้าเปลี่ยนเป็นบุคคลธรรมดา
    if (value === "individual") {
      setContacts([{ id: 1, ContactName: "", ContactPhone: "", ContactEmail: "", IsPrimary: true }]);
    }
  };
  
  // Handler สำหรับเพิ่มผู้ติดต่อ
  const addContact = () => {
    const newId = contacts.length > 0 ? Math.max(...contacts.map(c => c.id)) + 1 : 1;
    setContacts([...contacts, { 
      id: newId, 
      ContactName: "", 
      ContactPhone: "", 
      ContactEmail: "", 
      IsPrimary: false 
    }]);
  };
  
  // Handler สำหรับลบผู้ติดต่อ
  const removeContact = (id) => {
    if (contacts.length > 1) {
      const updatedContacts = contacts.filter(c => c.id !== id);
      // ถ้าลบตัวที่เป็น primary ให้ตั้ง primary ใหม่
      if (!updatedContacts.some(c => c.IsPrimary) && updatedContacts.length > 0) {
        updatedContacts[0].IsPrimary = true;
      }
      setContacts(updatedContacts);
    }
  };
  
  // Handler สำหรับอัปเดตข้อมูลผู้ติดต่อ
  const handleContactChange = (id, field, value) => {
    setContacts(contacts.map(contact => 
      contact.id === id ? { ...contact, [field]: value } : contact
    ));
  };
  
  // Handler สำหรับตั้ง primary contact
  const setPrimaryContact = (id) => {
    setContacts(contacts.map(contact => ({
      ...contact,
      IsPrimary: contact.id === id
    })));
  };

  // useEffect สำหรับจัดการการคัดลอกที่อยู่
  useEffect(() => {
    if (useSameAddress) {
      setFormData((prev) => ({
        ...prev,
        FarmAddress: {
          AddressNo: prev.AddressNo,
          AddressMoo: prev.AddressMoo,
          AddressRoad: prev.AddressRoad,
          AddressSubdistrict: prev.AddressSubdistrict,
          AddressDistrict: prev.AddressDistrict,
          AddressProvince: prev.AddressProvince,
          AddressZipcode: prev.AddressZipcode,
        },
      }));
    } else {
      // Optional: clear fields when unchecked
      setFormData((prev) => ({
        ...prev,
        FarmAddress: {
          AddressNo: "",
          AddressMoo: "",
          AddressRoad: "",
          AddressSubdistrict: "",
          AddressDistrict: "",
          AddressProvince: "",
          AddressZipcode: "",
        },
      }));
    }
  }, [
    useSameAddress,
    formData.AddressNo,
    formData.AddressMoo,
    formData.AddressRoad,
    formData.AddressSubdistrict,
    formData.AddressDistrict,
    formData.AddressProvince,
    formData.AddressZipcode,
  ]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    validateField(name, value);
  };

  // Handler สำหรับอัปเดตข้อมูลที่อยู่ของฟาร์ม
  const handleFarmAddressChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      FarmAddress: {
        ...prev.FarmAddress,
        [name]: value,
      },
    }));
  };

  const handleLivestockChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      Livestock: {
        ...prev.Livestock,
        [name]: value,
      },
    }));
  };

  const handleDateChange = (date) => {
    setFormData({ ...formData, BirthDate: date });
    validateField("BirthDate", date);
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      if (file) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setFormData({ ...formData, ProfileImage: reader.result });
        };
        reader.readAsDataURL(file);
      }
    },
  });

  const validateField = (name, value) => {
    let newErrors = { ...errors };
    switch (name) {
      case "IDCard":
        if (registrationType === "individual") {
          // บุคคลธรรมดา: เลขบัตรประชาชน 13 หลัก
          if (!/^\d{13}$/.test(value)) {
            newErrors[name] = "เลขบัตรประชาชนต้องเป็นตัวเลข 13 หลัก";
          } else {
            delete newErrors[name];
          }
        } else {
          // นิติบุคคล: เลขทะเบียนนิติบุคคล 13 หลัก
          if (!/^\d{13}$/.test(value)) {
            newErrors[name] = "เลขทะเบียนนิติบุคคลต้องเป็นตัวเลข 13 หลัก";
          } else {
            delete newErrors[name];
          }
        }
        break;
      case "Email":
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
          newErrors[name] = "รูปแบบอีเมลไม่ถูกต้อง";
        } else {
          delete newErrors[name];
        }
        break;
      case "BirthDate":
        // ไม่บังคับสำหรับทั้งบุคคลธรรมดาและนิติบุคคล
        delete newErrors[name];
        break;
      case "Password":
        if (!value) {
          newErrors[name] = "กรุณากรอกรหัสผ่าน";
        } else if (value.length < 6) {
          newErrors[name] = "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร";
        } else {
          delete newErrors[name];
        }
        break;
      case "ConfirmPassword":
        if (!value) {
          newErrors[name] = "กรุณายืนยันรหัสผ่าน";
        } else if (value !== formData.Password) {
          newErrors[name] = "รหัสผ่านไม่ตรงกัน";
        } else {
          delete newErrors[name];
        }
        break;
      case "CorporateType":
        if (registrationType === "corporate" && !value) {
          newErrors[name] = "กรุณาเลือกประเภทนิติบุคคล";
        } else {
          delete newErrors[name];
        }
        break;
      default:
        // สำหรับบุคคลธรรมดา
        if (registrationType === "individual") {
          if (
            !value &&
            [
              "FirstName",
              "LastName",
              "IDCard",
              "Email",
              "Phone",
            ].includes(name)
          ) {
            newErrors[name] = "กรุณากรอกข้อมูล";
          } else {
            delete newErrors[name];
          }
        } else {
          // สำหรับนิติบุคคล
          if (
            !value &&
            [
              "FirstName", // ชื่อนิติบุคคล
              "IDCard", // เลขทะเบียนนิติบุคคล
              "Email",
              "Phone",
            ].includes(name)
          ) {
            newErrors[name] = "กรุณากรอกข้อมูล";
          } else {
            delete newErrors[name];
          }
        }
    }
    setErrors(newErrors);
  };

  useEffect(() => {
    if (!isEditMode) {
      setFormData((prev) => ({ ...prev, FarmerID: prev.IDCard }));
    }
  }, [formData.IDCard, isEditMode]);

  const isFormValid = () => {
    const baseValidation = 
      formData.FirstName.trim() !== "" &&
      formData.IDCard.trim() !== "" &&
      /^\d{13}$/.test(formData.IDCard) &&
      formData.Email.trim() !== "" &&
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.Email) &&
      formData.Phone.trim() !== "" &&
      formData.Password.trim() !== "" &&
      formData.ConfirmPassword === formData.Password &&
      Object.keys(errors).length === 0 &&
      privacyChecked;
    
    if (registrationType === "individual") {
      // บุคคลธรรมดา: ต้องมีนามสกุล (เพศและวันเกิดไม่บังคับ)
      return baseValidation && formData.LastName.trim() !== "";
    } else {
      // นิติบุคคล: ต้องมีประเภทนิติบุคคล และต้องมีผู้ติดต่ออย่างน้อย 1 คน
      const hasValidContact = contacts.some(c => 
        c.ContactName.trim() !== "" && 
        (c.ContactPhone.trim() !== "" || c.ContactEmail.trim() !== "")
      );
      return baseValidation && 
        formData.CorporateType.trim() !== "" &&
        hasValidContact;
    }
  };

  const handleSubmit = async () => {
    if (!isFormValid()) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง");
      return;
    }

    const submitData = {
      ...formData,
      BirthDate: formData.BirthDate,
      ProfileImage: formData.ProfileImage || "",
      FarmerType: registrationType === "individual" ? "บุคคลธรรมดา" : "นิติบุคคล",
    };
    
    // เพิ่มข้อมูลผู้ติดต่อประสานงาน (สำหรับนิติบุคคล)
    if (registrationType === "corporate") {
      submitData.Contacts = contacts.filter(c => 
        c.ContactName.trim() !== "" && 
        (c.ContactPhone.trim() !== "" || c.ContactEmail.trim() !== "")
      ).map(({ id, ...rest }) => rest); // ลบ id ออกก่อนส่ง
      
      // สำหรับนิติบุคคล ใช้ FirstName เป็นชื่อนิติบุคคล และไม่ต้องมี LastName
      submitData.LastName = "";
    }

    try {
      const response = await ApiService({
        method: "POST",
        url: "/registerFarmer",
        data: submitData,
        sessionId: sessionId,
      });
      if (response.result !== "success") {
        if (response.code === "duplicate_registration") {
          onDuplicateDialogOpen();
        } else {
          alert(response.error || "เกิดข้อผิดพลาดในการลงทะเบียน");
        }
        return;
      }
      onSuccessDialogOpen();
    } catch (error) {
      alert("เกิดข้อผิดพลาดในการลงทะเบียน: " + error.message);
    }
  };

  const handleResendVerification = async () => {
    const email = formData.Email?.trim();
    if (!email) {
      toast({ title: "ไม่พบอีเมลในฟอร์ม", status: "warning", duration: 4000, isClosable: true });
      return;
    }
    setResendLoading(true);
    try {
      const res = await ApiService({
        method: "POST",
        url: "/resendVerificationEmail",
        data: { email },
        sessionId: "",
      });
      if (res.result === "success") {
        toast({ title: res.message || "ส่งลิงก์ยืนยันอีเมลแล้ว", status: "success", duration: 6000, isClosable: true });
        onDuplicateDialogClose();
      } else {
        toast({ title: res.error || res.message || "ส่งลิงก์ไม่สำเร็จ", status: "error", duration: 5000, isClosable: true });
      }
    } catch (err) {
      toast({ title: err.message || "เกิดข้อผิดพลาด", status: "error", duration: 5000, isClosable: true });
    } finally {
      setResendLoading(false);
    }
  };

  const handleGoToForgotPassword = () => {
    onDuplicateDialogClose();
    navigate("/login", { state: { openForgotPassword: true } });
  };

  const handleSuccessDialogClose = () => {
    onSuccessDialogClose();
    navigate("/home");
  };

  const livestockTypes = [
    { key: "BeefCattle", label: "โคเนื้อ" },
    { key: "DairyCattle", label: "โคนม" },
    { key: "Buffalo", label: "กระบือ" },
    { key: "Swine", label: "สุกร" },
    { key: "Chicken", label: "ไก่" },
    { key: "Duck", label: "เป็ด" },
    { key: "Goat", label: "แพะ" },
    { key: "Sheep", label: "แกะ" },
    { key: "Quail", label: "นกกระทา" },
    { key: "Dog", label: "สุนัข" },
    { key: "Cat", label: "แมว" },
    { key: "Other", label: "สัตว์อื่นๆ" },
  ];

  const farmAddressFields = [
    { key: "AddressNo", label: "เลขที่" },
    { key: "AddressMoo", label: "หมู่" },
    { key: "AddressRoad", label: "ถนน" },
    { key: "AddressSubdistrict", label: "ตำบล" },
    { key: "AddressDistrict", label: "อำเภอ" },
    { key: "AddressProvince", label: "จังหวัด" },
    { key: "AddressZipcode", label: "รหัสไปรษณีย์" },
  ];

  return (
    // <-- ADJUSTED: ปรับ p และ m ให้ responsive
    <Box p={{ base: 4, md: 6 }} m={{ base: 2, md: 6 }} borderWidth={1} borderRadius="lg" boxShadow="lg">
      <StandardPageTitle title="ลงทะเบียนเกษตรกร / ประชาชนทั่วไป" />

      {/* Box 1: ข้อมูลทั่วไป */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลทั่วไป"
          bgColor="iTeal.600"
          icon={faAddressCard}
        />
        
        {/* ตัวเลือกรูปแบบการลงทะเบียน */}
        <Box p={5} mb={4}>
          <FormControl>
            <FormLabel fontSize="xl" color="gray" mb={3}>
              รูปแบบการลงทะเบียน <Text as="span" color="red">*</Text>
            </FormLabel>
            <RadioGroup value={registrationType} onChange={handleRegistrationTypeChange}>
              <Stack direction={{ base: "column", md: "row" }} spacing={6}>
                <Radio value="individual" colorScheme="iTeal" size="lg">
                  <HStack spacing={2}>
                    <FontAwesomeIcon icon={faUser} />
                    <Text fontSize="lg">บุคคลธรรมดา</Text>
                  </HStack>
                </Radio>
                <Radio value="corporate" colorScheme="iTeal" size="lg">
                  <HStack spacing={2}>
                    <FontAwesomeIcon icon={faBuilding} />
                    <Text fontSize="lg">นิติบุคคล</Text>
                  </HStack>
                </Radio>
              </Stack>
            </RadioGroup>
          </FormControl>
        </Box>
        
        <Divider mb={4} />
        
        {/* ฟอร์มสำหรับบุคคลธรรมดา */}
        {registrationType === "individual" && (
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
            {["FirstName", "LastName", "IDCard", "Gender", "BirthDate"].map(
              (key) => (
                <GridItem colSpan={1} key={key}>
                  <FormControl 
                    isRequired={["FirstName", "LastName", "IDCard"].includes(key)} 
                    isInvalid={!!errors[key]}
                  >
                    <FormLabel fontSize="xl" color="gray">
                      {key === "FirstName"
                        ? "ชื่อ"
                        : key === "LastName"
                        ? "นามสกุล"
                        : key === "IDCard"
                        ? "เลขบัตรประชาชน"
                        : key === "Gender"
                        ? "เพศ"
                        : "วันเกิด (วัน/เดือน/ปี พ.ศ.)"}
                      {["FirstName", "LastName", "IDCard"].includes(key) && (
                        <Text as="span" color="red"> *</Text>
                      )}
                    </FormLabel>
                    {key === "Gender" ? (
                      <Select
                        name={key}
                        value={formData[key]}
                        onChange={handleInputChange}
                        colorScheme="iTeal"
                      >
                        <option value="">-- เลือก --</option>
                        <option value="M">ชาย</option>
                        <option value="F">หญิง</option>
                      </Select>
                    ) : key === "BirthDate" ? (
                      <CustomDatePicker
                        name={key}
                        value={formData.BirthDate}
                        onChange={handleInputChange}
                        colorScheme="iTeal"
                      />
                    ) : (
                      <Input
                        name={key}
                        value={formData[key]}
                        onChange={handleInputChange}
                        readOnly={key === "FarmerID"}
                        colorScheme="iTeal"
                      />
                    )}
                    <FormErrorMessage>{errors[key]}</FormErrorMessage>
                  </FormControl>
                </GridItem>
              )
            )}
          </Grid>
        )}
        
        {/* ฟอร์มสำหรับนิติบุคคล */}
        {registrationType === "corporate" && (
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
            {/* ประเภทนิติบุคคล */}
            <GridItem colSpan={1}>
              <FormControl isRequired isInvalid={!!errors.CorporateType}>
                <FormLabel fontSize="xl" color="gray">
                  ประเภทนิติบุคคล <Text as="span" color="red">*</Text>
                </FormLabel>
                <Select
                  name="CorporateType"
                  value={formData.CorporateType}
                  onChange={handleInputChange}
                  placeholder="-- เลือกประเภทนิติบุคคล --"
                  colorScheme="iTeal"
                >
                  {corporateTypes.map((type) => (
                    <option key={type} value={type}>{type}</option>
                  ))}
                </Select>
                <FormErrorMessage>{errors.CorporateType}</FormErrorMessage>
              </FormControl>
            </GridItem>
            
            {/* ชื่อนิติบุคคล */}
            <GridItem colSpan={{ base: 1, lg: 2 }}>
              <FormControl isRequired isInvalid={!!errors.FirstName}>
                <FormLabel fontSize="xl" color="gray">
                  ชื่อนิติบุคคล <Text as="span" color="red">*</Text>
                </FormLabel>
                <Input
                  name="FirstName"
                  value={formData.FirstName}
                  onChange={handleInputChange}
                  placeholder="ใส่ชื่อเต็ม เช่น บริษัท ทดสอบ จำกัด"
                  colorScheme="iTeal"
                />
                <Text fontSize="sm" color="gray.500" mt={1}>
                  กรุณาใส่ชื่อเต็มของนิติบุคคล เช่น บริษัท ทดสอบ จำกัด, ห้างหุ้นส่วนจำกัด ตัวอย่าง เป็นต้น
                </Text>
                <FormErrorMessage>{errors.FirstName}</FormErrorMessage>
              </FormControl>
            </GridItem>
            
            {/* สาขา */}
            <GridItem colSpan={1}>
              <FormControl>
                <FormLabel fontSize="xl" color="gray">
                  สาขา
                </FormLabel>
                <Input
                  name="CompanyBranch"
                  value={formData.CompanyBranch}
                  onChange={handleInputChange}
                  placeholder="สำนักงานใหญ่ / สาขาที่..."
                  colorScheme="iTeal"
                />
              </FormControl>
            </GridItem>
            
            {/* เลขทะเบียนนิติบุคคล */}
            <GridItem colSpan={{ base: 1, lg: 2 }}>
              <FormControl isRequired isInvalid={!!errors.IDCard}>
                <FormLabel fontSize="xl" color="gray">
                  เลขทะเบียนนิติบุคคล <Text as="span" color="red">*</Text>
                </FormLabel>
                <Input
                  name="IDCard"
                  value={formData.IDCard}
                  onChange={handleInputChange}
                  placeholder="เลขทะเบียนนิติบุคคล 13 หลัก"
                  colorScheme="iTeal"
                  maxLength={13}
                />
                <FormErrorMessage>{errors.IDCard}</FormErrorMessage>
              </FormControl>
            </GridItem>
          </Grid>
        )}
      </Box>
      
      {/* Box 1.5: ผู้ติดต่อประสานงาน (สำหรับนิติบุคคลเท่านั้น) */}
      {registrationType === "corporate" && (
        <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
          <StandardHeader
            title="ผู้ติดต่อประสานงาน"
            bgColor="iOrange.600"
            icon={faUserTie}
          />
          <VStack spacing={4} p={5} align="stretch">
            <Text color="gray.600" mb={2}>
              กรุณาระบุข้อมูลผู้ติดต่อประสานงาน (สามารถเพิ่มได้มากกว่า 1 คน)
            </Text>
            
            {contacts.map((contact, index) => (
              <Box 
                key={contact.id} 
                p={4} 
                borderWidth={1} 
                borderRadius="md" 
                borderColor={contact.IsPrimary ? "iOrange.300" : "gray.200"}
                bg={contact.IsPrimary ? "orange.50" : "white"}
              >
                <HStack justify="space-between" mb={3}>
                  <HStack>
                    <Badge colorScheme={contact.IsPrimary ? "orange" : "gray"}>
                      {contact.IsPrimary ? "ผู้ติดต่อหลัก" : `ผู้ติดต่อ ${index + 1}`}
                    </Badge>
                  </HStack>
                  <HStack spacing={2}>
                    {!contact.IsPrimary && (
                      <Button 
                        size="sm" 
                        colorScheme="orange" 
                        variant="outline"
                        onClick={() => setPrimaryContact(contact.id)}
                      >
                        ตั้งเป็นผู้ติดต่อหลัก
                      </Button>
                    )}
                    {contacts.length > 1 && (
                      <IconButton
                        aria-label="ลบผู้ติดต่อ"
                        icon={<FontAwesomeIcon icon={faTrash} />}
                        size="sm"
                        colorScheme="red"
                        variant="outline"
                        onClick={() => removeContact(contact.id)}
                      />
                    )}
                  </HStack>
                </HStack>
                
                <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={4}>
                  <GridItem>
                    <FormControl isRequired={index === 0}>
                      <FormLabel color="gray.600">
                        ชื่อ-นามสกุล {index === 0 && <Text as="span" color="red">*</Text>}
                      </FormLabel>
                      <Input
                        value={contact.ContactName}
                        onChange={(e) => handleContactChange(contact.id, 'ContactName', e.target.value)}
                        placeholder="ชื่อ-นามสกุล ผู้ติดต่อ"
                        colorScheme="iOrange"
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem>
                    <FormControl>
                      <FormLabel color="gray.600">เบอร์โทรศัพท์</FormLabel>
                      <Input
                        value={contact.ContactPhone}
                        onChange={(e) => handleContactChange(contact.id, 'ContactPhone', e.target.value)}
                        placeholder="0xx-xxx-xxxx"
                        colorScheme="iOrange"
                      />
                    </FormControl>
                  </GridItem>
                  <GridItem>
                    <FormControl>
                      <FormLabel color="gray.600">อีเมล</FormLabel>
                      <Input
                        value={contact.ContactEmail}
                        onChange={(e) => handleContactChange(contact.id, 'ContactEmail', e.target.value)}
                        placeholder="email@example.com"
                        type="email"
                        colorScheme="iOrange"
                      />
                    </FormControl>
                  </GridItem>
                </Grid>
              </Box>
            ))}
            
            <Button
              leftIcon={<FontAwesomeIcon icon={faPlus} />}
              colorScheme="iOrange"
              variant="outline"
              onClick={addContact}
              alignSelf="flex-start"
            >
              เพิ่มผู้ติดต่อ
            </Button>
          </VStack>
        </Box>
      )}

      {/* Box 2: ข้อมูลการติดต่อ */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลการติดต่อ"
          bgColor="iBlue.600"
          icon={faLocationDot}
        />
        {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
          {[
            "AddressNo",
            "AddressMoo",
            "AddressRoad",
            "AddressSubdistrict",
            "AddressDistrict",
            "AddressProvince",
            "AddressZipcode",
            "Email",
            "Phone",
          ].map((key) => (
            <GridItem colSpan={1} key={key}>
              <FormControl
                isRequired={["Email", "Phone"].includes(key)}
                isInvalid={!!errors[key]}
              >
                <FormLabel fontSize="xl" color="gray">
                  {key === "Email"
                    ? "อีเมลล์"
                    : key === "Phone"
                    ? "เบอร์โทรศัพท์"
                    : key === "AddressNo"
                    ? "เลขที่"
                    : key === "AddressMoo"
                    ? "หมู่"
                    : key === "AddressRoad"
                    ? "ถนน"
                    : key === "AddressSubdistrict"
                    ? "ตำบล"
                    : key === "AddressDistrict"
                    ? "อำเภอ"
                    : key === "AddressProvince"
                    ? "จังหวัด"
                    : key === "AddressZipcode"
                    ? "รหัสไปรษณีย์"
                    : "ที่อยู่"}
                  {["Email", "Phone"].includes(key) ? (
                    <Text as="span" color="red">
                      {" "}
                      *
                    </Text>
                  ) : null}
                </FormLabel>
                <Input
                  name={key}
                  value={formData[key]}
                  onChange={handleInputChange}
                  colorScheme="iBlue"
                />
                <FormErrorMessage>{errors[key]}</FormErrorMessage>
              </FormControl>
            </GridItem>
          ))}
        </Grid>
      </Box>

      {/* Box 3: ข้อมูลปศุสัตว์ */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ข้อมูลปศุสัตว์"
          bgColor="iGreen.600"
          icon={faHatCowboy}
        />
        <VStack spacing={5} p={5} align="flex-start">
          {/* <-- ADJUSTED: Grid ของชื่อฟาร์ม */}
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} w="100%">
            {/* <-- ADJUSTED: ทำให้ colSpan responsive */}
            <GridItem colSpan={{ base: 1, lg: 2 }}>
              <FormControl>
                <FormLabel fontSize="xl" color="gray">
                  ชื่อฟาร์ม / ชื่อบริษัท
                </FormLabel>
                <Input
                  name="FarmName"
                  value={formData.FarmName}
                  onChange={handleInputChange}
                  colorScheme="iGreen"
                />
              </FormControl>
            </GridItem>
          </Grid>

          <FormControl>
            <FormLabel fontSize="xl" color="gray">
              สถานที่ตั้ง
            </FormLabel>
            <Checkbox
              isChecked={useSameAddress}
              onChange={(e) => setUseSameAddress(e.target.checked)}
              colorScheme="iGreen"
              size="lg"
            >
              ใช้ที่อยู่เดียวกับข้อมูลการติดต่อ
            </Checkbox>
          </FormControl>

          {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
          <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} w="100%">
            {farmAddressFields.map((field) => (
              <GridItem colSpan={1} key={field.key}>
                <FormControl>
                  <FormLabel color="gray.600">{field.label}</FormLabel>
                  <Input
                    name={field.key}
                    value={formData.FarmAddress[field.key]}
                    onChange={handleFarmAddressChange}
                    isDisabled={useSameAddress} // Disable if checkbox is checked
                    colorScheme="iGreen"
                  />
                </FormControl>
              </GridItem>
            ))}
          </Grid>

          <FormControl>
            <FormLabel fontSize="xl" color="gray" mb={4}>
              จำนวนปศุสัตว์
            </FormLabel>
            {/* <-- ADJUSTED: ทำให้ Grid เป็น 1, 2, และ 4 คอลัมน์ตามขนาดจอ */}
            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", xl: "repeat(4, 1fr)" }} gap={5}>
              {livestockTypes.map((animal) => (
                <GridItem key={animal.key}>
                  <FormControl>
                    <FormLabel color="gray.600">{animal.label}</FormLabel>
                    <NumberInput
                      min={0}
                      value={formData.Livestock[animal.key]}
                      onChange={(valueString) =>
                        handleLivestockChange(
                          animal.key,
                          parseInt(valueString) || 0
                        )
                      }
                    >
                      <NumberInputField colorScheme="iGreen" />
                      <NumberInputStepper>
                        <NumberIncrementStepper />
                        <NumberDecrementStepper />
                      </NumberInputStepper>
                    </NumberInput>
                  </FormControl>
                </GridItem>
              ))}
            </Grid>
          </FormControl>
        </VStack>
      </Box>

      {/* Box 4: รูปโปรไฟล์ (แสดงเฉพาะโหมดแก้ไข) */}
      {isEditMode && (
        <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
          <StandardHeader
            title="รูปโปรไฟล์"
            bgColor="iOrange.600"
            icon={faImage}
          />
          <Box
            {...getRootProps()}
            borderWidth={2}
            borderStyle="dashed"
            borderRadius="md"
            // <-- ADJUSTED: ปรับความกว้างให้ responsive
            w={{ base: "100%", md: "70%" }}
            p={5}
            textAlign="center"
            cursor="pointer"
            mt={5}
          >
            <Input {...getInputProps()} colorScheme="iGreen" />
            {formData.ProfileImage ? (
              <Image
                src={formData.ProfileImage}
                alt="Profile Preview"
                maxH="200px"
                mx="auto"
              />
            ) : (
              <Text h={20}>ลากและวางรูปภาพที่นี่ หรือคลิกเพื่อเลือกไฟล์</Text>
            )}
          </Box>
        </Box>
      )}

      {/* Box 5: ชื่อผู้ใช้และรหัสผ่าน */}
      <Box borderWidth={1} borderRadius="lg" boxShadow="lg" p={5} mb={6}>
        <StandardHeader
          title="ชื่อผู้ใช้และรหัสผ่าน"
          bgColor="iPurple.600"
          icon={faUser}
        />
        {/* <-- ADJUSTED: ทำให้ Grid เป็น 1 คอลัมน์บนมือถือ และ 3 คอลัมน์บนจอใหญ่ */}
        <Grid templateColumns={{ base: "1fr", lg: "repeat(3, 1fr)" }} gap={6} p={5}>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["Email"]}>
              <FormLabel fontSize="xl" color="gray">
                ชื่อผู้ใช้ (อีเมลล์){" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="Email"
                value={formData.Email}
                onChange={handleInputChange}
                isDisabled={isEditMode}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["Email"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["Password"]}>
              <FormLabel fontSize="xl" color="gray">
                รหัสผ่าน{" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="Password"
                type="password"
                value={formData.Password}
                onChange={handleInputChange}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["Password"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
          <GridItem>
            <FormControl isRequired isInvalid={!!errors["ConfirmPassword"]}>
              <FormLabel fontSize="xl" color="gray">
                ยืนยันรหัสผ่าน{" "}
                <Text as="span" color="red">
                  {" "}
                  *
                </Text>
              </FormLabel>
              <Input
                name="ConfirmPassword"
                type="password"
                value={formData.ConfirmPassword}
                onChange={handleInputChange}
                colorScheme="iPurple"
              />
              <FormErrorMessage>{errors["ConfirmPassword"]}</FormErrorMessage>
            </FormControl>
          </GridItem>
        </Grid>
      </Box>

      {/* <-- ADJUSTED: ปรับ p และ m ให้เล็กลง */}
      <Box p={{ base: 2, md: 5 }} m={{ base: 2, md: 5 }}>
        <Checkbox
          mt={3}
          onChange={(e) => setPrivacyChecked(e.target.checked)}
          size="lg"
          colorScheme="iOrange"
        >
          ฉันได้อ่านนโยบายความเป็นส่วนตัวและเข้าใจนโยบายความเป็นส่วนตัวของเราแล้ว
          และยอมรับเงื่อนไขการใช้งาน รวมถึงนโยบายความเป็นส่วนตัวของเรา
          และยอมรับการใช้งานของคุกกี้ และเทคโนโลยีต่างๆ ที่เกี่ยวข้อง
        </Checkbox>
      </Box>

      {/* <-- ADJUSTED: ปรับ p และ m ให้เล็กลง */}
      <Box p={{ base: 2, md: 5 }} m={{ base: 2, md: 5 }}>
        <Button
          colorScheme="blue"
          mt={5}
          onClick={handleSubmit}
          isDisabled={!isFormValid()}
          // <-- ADJUSTED: ทำให้ปุ่มเต็มความกว้างบนมือถือ
          w={{ base: "full", md: "auto" }}
        >
          {isEditMode ? "บันทึกการเปลี่ยนแปลง" : "ลงทะเบียน"}
        </Button>
      </Box>

      {/* Dialog แจ้งหลังลงทะเบียนสำเร็จ */}
      <Modal isOpen={isSuccessDialogOpen} onClose={handleSuccessDialogClose} isCentered size="md">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ลงทะเบียนเรียบร้อย</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>
              ระบบได้รับข้อมูลการลงทะเบียนของท่านแล้ว
              กรุณายืนยันตัวตนตามลิงก์ที่ส่งไปยังอีเมลของท่าน
              หลังจากยืนยันแล้วจึงสามารถเข้าสู่ระบบได้
            </Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" onClick={handleSuccessDialogClose}>
              ตกลง
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Dialog กรณีเลขบัตร/อีเมลอยู่ในระบบแล้ว */}
      <Modal isOpen={isDuplicateDialogOpen} onClose={onDuplicateDialogClose} isCentered size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="orange.600">ลงทะเบียนไม่ได้</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack align="stretch" spacing={4}>
              <Text>
                มีเลขบัตรประชาชน หรืออีเมลนี้อยู่ในระบบแล้ว
              </Text>
              <Text fontSize="sm" color="gray.600">
                - ในกรณีที่ลืมรหัสผ่าน ท่านสามารถตั้งค่ารหัสผ่านใหม่ได้ โดยกดปุ่ม <strong>ลืมรหัสผ่าน</strong> ได้ที่หน้าเข้าสู่ระบบ
                - ในกรณีที่ยังไม่ได้ยืนยันอีเมล สามารถกดปุ่ม <strong>ส่งลิงก์ยืนยันตัวตนใหม่</strong> ไปที่อีเมลที่เคยลงทะเบียนไว้ได้
              </Text>
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onDuplicateDialogClose}>
              ปิด
            </Button>
            <Button colorScheme="teal" variant="outline" mr={3} onClick={handleGoToForgotPassword}>
              ไปหน้าลืมรหัสผ่าน
            </Button>
            <Button
              colorScheme="blue"
              onClick={handleResendVerification}
              isLoading={resendLoading}
              loadingText="กำลังส่ง..."
            >
              ส่งลิงก์ยืนยันอีเมลใหม่
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default RegistrationFarmer;